import React from "react";
import {CButton, CCol, CRow} from "@coreui/react";

const Search = (props) => {
    return <>
        <CRow>
            <CCol>
                <CButton size="lg"
                         onClick={() => {
                             props.onSearch()
                         }}
                         component="input" type="submit" color="primary" value="Search"/>
            </CCol>
        </CRow>
    </>;
}

export default Search;
